import React from "react";
import defaultStyle from "../../../utils/default";

function Description({ description, className, color }) {
  return (
    <h2
      className={className}
      style={{ color: color?.color?.primary || defaultStyle.color.primary }}
    >
      {description}
    </h2>
  );
}

export default Description;
